// TODO: [PRO-3634] `displayContent` convention for localization. Turn text to translate into a localization en-US.json
export const displayContent = {
  clear: 'Clear',
  delete: 'Delete',
  disabledNewTemplateTooltip:
    'You do not have permissions to create new templates. Please contact your admin to get permissions.',
  emptyState: 'This folder is empty.',
  exportHtml: 'Export HTML',
  importTemplate: 'Import email template',
  moveToFolder: 'Move to folder',
  newTemplate: 'New template',
  searchPlaceholder: 'Search templates',
  title: 'Templates',
};

export type DisplayContent = typeof displayContent;
